module.exports = __webpack_public_path__ + "img/pwa-install-popup-btn.d9e11906.png";